// extracted by mini-css-extract-plugin
module.exports = {"navLink":"HeaderNav_navLink__2PK0c","active":"HeaderNav_active__3Pp7_","linkWrapper":"HeaderNav_linkWrapper__2hdCZ","verifiedIcon":"HeaderNav_verifiedIcon__2ianT"};